export default "__VITE_ASSET__C8ZwcqiK__"